import { render, staticRenderFns } from "./GreyPage.vue?vue&type=template&id=02abdd53&scoped=true&lang=pug&functional=true&"
var script = {}
import style0 from "./GreyPage.vue?vue&type=style&index=0&id=02abdd53&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "02abdd53",
  null
  
)

export default component.exports